import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { SessionStorageService, SessionStorage } from 'ngx-webstorage';
import { addDays, isSameDay, isWeekend, startOfDay } from 'date-fns';
import { ConfigService } from 'services/config/config.service';
import { CategoryPipe } from 'pipes/category.pipe';
import { ReferralFacilitatorStatusPipe } from 'pipes/referralfacilitatorstatus.pipe';
import { ReferralStatusPipe } from 'pipes/referralstatus.pipe';
import { RequestIssuePipe } from 'pipes/requestissue.pipe';
import { RequestStatusPipe } from 'pipes/requeststatus.pipe';
import { TitleCasePipe } from 'pipes/titlecase.pipe';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../pipes/category.pipe";
import * as i3 from "../config/config.service";
import * as i4 from "ngx-webstorage";
import * as i5 from "../../pipes/referralfacilitatorstatus.pipe";
import * as i6 from "../../pipes/referralstatus.pipe";
import * as i7 from "../../pipes/requestissue.pipe";
import * as i8 from "../../pipes/requeststatus.pipe";
import * as i9 from "../../pipes/titlecase.pipe";
var ApplicationService = /** @class */ (function () {
    function ApplicationService(http, categoryPipe, configService, storage, referralFacilitatorStatusPipe, referralStatusPipe, requestIssuePipe, requestStatusPipe, titleCasePipe) {
        this.http = http;
        this.categoryPipe = categoryPipe;
        this.configService = configService;
        this.storage = storage;
        this.referralFacilitatorStatusPipe = referralFacilitatorStatusPipe;
        this.referralStatusPipe = referralStatusPipe;
        this.requestIssuePipe = requestIssuePipe;
        this.requestStatusPipe = requestStatusPipe;
        this.titleCasePipe = titleCasePipe;
        this.DevSiteSubject = new BehaviorSubject(false);
        this.ThemeSubject = new BehaviorSubject(false);
        this.CurrentRequestSubject = new BehaviorSubject(null);
        this.DevSite = window.location.hostname.indexOf('localhost') >= 0 || window.location.hostname.indexOf('polkawardsdev') >= 0;
        // Anything with dates must be reparsed in case this is a page refresh retrieving from session variables
        this.CurrentRequestSubject.next(this._CurrentRequest);
        (this._WorkdayCalendars || []).forEach(function (c) {
            c.CalendarDate = c.CalendarDate ? new Date(c.CalendarDate) : null;
        });
    }
    Object.defineProperty(ApplicationService.prototype, "DevSite", {
        // #region Getters and Setters
        get: function () {
            return this.DevSiteSubject.value;
        },
        set: function (value) {
            this.DevSiteSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplicationService.prototype, "CurrentRequest", {
        get: function () {
            return this.CurrentRequestSubject.value;
        },
        set: function (value) {
            this.CurrentRequestSubject.next(value);
            this._CurrentRequest = value;
        },
        enumerable: true,
        configurable: true
    });
    // #region Add Board Assistant Service Call
    ApplicationService.prototype.AddBoardAssistant = function (AuthToken, CurrentRole, SAPID, PositionNo) {
        return this.http.get(this.configService.hostAddress +
            "Api/Services/IRIS/AddBoardAssistant" +
            ("?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&SAPID=" + (SAPID || '') + "&PositionNo=" + (PositionNo || '')));
    };
    // #endregion
    // #region Add Board Note To Request Service Call
    ApplicationService.prototype.AddBoardNoteToRequest = function (AuthToken, CurrentRole, RequestID, Note) {
        return this.http.post(this.configService.hostAddress + "Api/Services/IRIS/AddBoardNoteToRequest", {
            AuthToken: AuthToken || '',
            CurrentRole: CurrentRole || '',
            RequestID: RequestID != null ? RequestID : '',
            Note: Note || '',
        });
    };
    // #endregion
    // #region Add Cabinet Member Service Call
    ApplicationService.prototype.AddCabinetMember = function (AuthToken, CurrentRole, SAPID, PositionNo, CabinetType) {
        var _this = this;
        return this.http
            .get(this.configService.hostAddress +
            "Api/Services/IRIS/AddCabinetMember" +
            ("?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&SAPID=" + (SAPID || '')) +
            ("&PositionNo=" + (PositionNo || '') + "&CabinetType=" + (CabinetType || '')))
            .pipe(map(function (cabinetmembers) {
            _this._AllCabinetMembers = cabinetmembers || [];
            return _this._AllCabinetMembers;
        }));
    };
    // #endregion
    // #region Add Facilitator Service Call
    ApplicationService.prototype.AddFacilitator = function (AuthToken, CurrentRole, SAPID, PositionNo) {
        return this.http.get(this.configService.hostAddress +
            "Api/Services/IRIS/AddFacilitator" +
            ("?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&SAPID=" + (SAPID || '') + "&PositionNo=" + (PositionNo || '')));
    };
    // #endregion
    // #region Add FollowUp Response Service Call
    ApplicationService.prototype.AddFollowUpResponse = function (AuthToken, CurrentRole, RequestID, FollowUpID, Note) {
        return this.http.post(this.configService.hostAddress + "Api/Services/IRIS/AddFollowUpResponse", {
            AuthToken: AuthToken || '',
            CurrentRole: CurrentRole || '',
            RequestID: RequestID != null ? RequestID : '',
            FollowUpID: FollowUpID != null ? FollowUpID : '',
            Note: Note || '',
        });
    };
    // #endregion
    // #region Add FollowUp To Request Service Call
    ApplicationService.prototype.AddFollowUpToRequest = function (AuthToken, CurrentRole, RequestID, Note) {
        return this.http.post(this.configService.hostAddress + "Api/Services/IRIS/AddFollowUpToRequest", {
            AuthToken: AuthToken || '',
            CurrentRole: CurrentRole || '',
            RequestID: RequestID != null ? RequestID : '',
            Note: Note || '',
        });
    };
    // #endregion
    // #region Add Referral Service Call
    ApplicationService.prototype.AddReferral = function (AuthToken, RequestDetails) {
        return this.http.post(this.configService.hostAddress + "Api/Services/IRIS/AddReferral", {
            AuthToken: AuthToken,
            infoObject: {
                RequestID: RequestDetails.RequestID,
                RequestedBySAPID: RequestDetails.RequestedBySAPID,
                SchoolNumber: RequestDetails.SchoolNumber,
                CategoryID: RequestDetails.RequestCategory.CategoryID,
                BoardDistrict: RequestDetails.BoardDistrict,
                Priority: RequestDetails.Priority,
                DueDate: RequestDetails.DueDate,
                SourceNotes: RequestDetails.SourceNotes,
            },
        });
    };
    // #endregion
    // #region Add Request Service Call
    ApplicationService.prototype.AddRequest = function (AuthToken, RequestDetails) {
        return this.http
            .post(this.configService.hostAddress + "Api/Services/IRIS/AddRequest", {
            AuthToken: AuthToken,
            infoObject: {
                RequestText: RequestDetails.RequestText || '',
                Source: RequestDetails.Source || '',
                SourceDescription: RequestDetails.SourceDescription || '',
                RequestedBySAPID: RequestDetails.RequestedBySAPID || '',
                Subject: RequestDetails.Subject || '',
                ConstituentName: RequestDetails.ConstituentName || '',
                ConstituentEmail: RequestDetails.ConstituentEmail || '',
                ConstituentPhone: RequestDetails.ConstituentPhone || '',
                ConstituentPrivate: RequestDetails.ConstituentPrivate != null ? RequestDetails.ConstituentPrivate : false,
                SchoolNumber: RequestDetails.SchoolNumber || '',
                CategoryID: RequestDetails.RequestCategory.CategoryID || '',
                BoardDistrict: RequestDetails.BoardDistrict || '',
                Priority: RequestDetails.Priority || '',
                Confidential: RequestDetails.Confidential != null ? RequestDetails.Confidential : '',
                DueDate: RequestDetails.DueDate || '',
                SourceNotes: RequestDetails.SourceNotes || '',
            },
        })
            .pipe(map(function (data) {
            if (data) {
                data.RequestID = data.RequestID;
                data.RequestIssueNumber = data.RequestIssueNumber;
            }
            return data;
        }));
    };
    // #endregion
    // #region Assign Request Service Call
    ApplicationService.prototype.AssignRequest = function (AuthToken, CurrentRole, RequestDetails) {
        return this.http.post(this.configService.hostAddress + "Api/Services/IRIS/AssignRequest", {
            AuthToken: AuthToken,
            CurrentRole: CurrentRole,
            infoObject: {
                RequestID: RequestDetails.RequestID,
                RequestedBySAPID: RequestDetails.RequestedBySAPID,
                SchoolNumber: RequestDetails.SchoolNumber,
                CategoryID: RequestDetails.RequestCategory.CategoryID,
                BoardDistrict: RequestDetails.BoardDistrict,
                Priority: RequestDetails.Priority,
                DueDate: RequestDetails.DueDate,
                SourceNotes: RequestDetails.SourceNotes,
                Confidential: RequestDetails.Confidential != null ? RequestDetails.Confidential : false,
            },
        });
    };
    // #endregion
    // #region Board Approve Referral Service Call
    ApplicationService.prototype.BoardApproveReferral = function (AuthToken, RequestID, ReferrerNotes) {
        return this.http.post(this.configService.hostAddress + "Api/Services/IRIS/BoardApproveReferral", {
            AuthToken: AuthToken,
            RequestID: RequestID,
            ReferrerNotes: ReferrerNotes,
        });
    };
    // #endregion
    // #region Close As Non Info Request Service Call
    ApplicationService.prototype.CloseAsNonInfoRequest = function (AuthToken, CurrentRole, RequestID) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/IRIS/CloseAsNonInfoRequest?AuthToken=" + (AuthToken || '') + "&") +
            ("CurrentRole=" + (CurrentRole || '') + "&RequestID=" + (RequestID || '')));
    };
    // #endregion
    // #region Deactivate Out Of Office Setting Service Call
    ApplicationService.prototype.DeactivateOutOfOfficeSetting = function (AuthToken, CurrentRole, OutOfOfficeSettingID, ToRemove) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/IRIS/DeactivateOutOfOfficeSetting?AuthToken=" + (AuthToken || '')) +
            ("&CurrentRole=" + (CurrentRole || '') + "&OutOfOfficeSettingID=" + (OutOfOfficeSettingID || '')) +
            ("&ToRemove=" + (ToRemove != null ? ToRemove : '')))
            .pipe(map(function (data) {
            if (data && data.length) {
                data.forEach(function (d) {
                    d.DateBegin = d.DateBegin ? new Date(d.DateBegin) : null;
                    d.DateEnd = d.DateEnd ? new Date(d.DateEnd) : null;
                });
            }
            return data;
        }));
    };
    // #endregion
    // #region Delete File Service Call
    ApplicationService.prototype.DeleteFile = function (AuthToken, IRISAttachmentID, FilePath) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/IRIS/DeleteFile?AuthToken=" + (AuthToken || '') + "&IRISAttachmentID=" + (IRISAttachmentID || '')) +
            ("&FilePath=" + (FilePath || '')));
    };
    // #endregion
    // #region Format Request Info
    ApplicationService.prototype.FormatRequestInfo = function (request, CurrentRole) {
        var self = this;
        if (!request) {
            return;
        }
        request.FormattedRequestIssueNumber = self.requestIssuePipe.transform(request.RequestIssueNumber, request.FiscalYear);
        // For priority, first save the original priority as it is coming in. Then, if the current request status is NEEDTIME (indicating
        // that we are holding for a board time request), we should virtually reset the priority to -1 (pending approval) so the UI indicates
        // this.
        request.OriginalPriority = request.Priority;
        if (request.Status === 'NEEDTIME') {
            request.Priority = -1;
        }
        request.PriorityShortLabel =
            request.Priority === -1
                ? 'Waiting for Approval'
                : request.Priority === 1
                    ? 'Urgent'
                    : request.Priority === 2
                        ? 'High'
                        : request.Priority === 3
                            ? 'Routine'
                            : request.Priority === 4
                                ? 'Low'
                                : 'Unassigned';
        request.PriorityLabel =
            request.Priority === -1 ? 'Waiting for Approval' : request.Priority + ' - ' + request.PriorityShortLabel;
        request.CategoryLabel = self.categoryPipe.transform(request.CategoryID, self._AllCategories);
        request.DateClosed = request.DateClosed ? new Date(request.DateClosed) : null;
        request.DateCreated = request.DateCreated ? new Date(request.DateCreated) : null;
        request.DateReferred = request.DateReferred ? new Date(request.DateReferred) : null;
        request.DateUpdated = request.DateUpdated ? new Date(request.DateUpdated) : null;
        request.DueDate = request.DueDate ? new Date(request.DueDate) : null;
        request.ReferralDateUpdated = request.ReferralDateUpdated ? new Date(request.ReferralDateUpdated) : null;
        request.SchoolNumber = request.SchoolNumber == null ? '' : request.SchoolNumber.replace(/\s/g, '');
        request.BoardDistrict = request.BoardDistrict == null ? '' : request.BoardDistrict.replace(/\s/g, '');
        switch (request.Status) {
            case 'DENIED':
            case 'UNAVAIL':
            case 'COMPLETED':
            case 'CANCEL':
            case 'CLOSEDNONINFO':
                request.RequestIsClosed = true;
                break;
            default:
                request.RequestIsClosed = false;
                break;
        }
        // Normalize the capitalization of the referred to person's name, the requestor's name, and the referrer's name (for any provided)
        if (request.RequestorInfo) {
            request.RequestorInfo.LastName = self.titleCasePipe.transform(request.RequestorInfo.LastName);
            request.RequestorInfo.FirstName = self.titleCasePipe.transform(request.RequestorInfo.FirstName);
            request.RequestorInfo.FullName =
                !!request.RequestorInfo.LastName && !!request.RequestorInfo.FirstName
                    ? request.RequestorInfo.LastName + ', ' + request.RequestorInfo.FirstName
                    : null;
            request.RequestorName = request.RequestorInfo.FullName;
        }
        if (request.ReferrerInfo) {
            request.ReferrerInfo.LastName = self.titleCasePipe.transform(request.ReferrerInfo.LastName);
            request.ReferrerInfo.FirstName = self.titleCasePipe.transform(request.ReferrerInfo.FirstName);
            request.ReferrerInfo.FullName =
                !!request.ReferrerInfo.LastName && !!request.ReferrerInfo.FirstName
                    ? request.ReferrerInfo.LastName + ', ' + request.ReferrerInfo.FirstName
                    : null;
        }
        if (request.ResponderInfo) {
            request.ResponderInfo.LastName = self.titleCasePipe.transform(request.ResponderInfo.LastName);
            request.ResponderInfo.FirstName = self.titleCasePipe.transform(request.ResponderInfo.FirstName);
            request.ResponderInfo.FullName =
                !!request.ResponderInfo.LastName && !!request.ResponderInfo.FirstName
                    ? request.ResponderInfo.LastName + ', ' + request.ResponderInfo.FirstName
                    : null;
            request.ResponderName = request.ResponderInfo.FullName;
        }
        if (request.SecondResponderInfo) {
            request.SecondResponderInfo.LastName = self.titleCasePipe.transform(request.SecondResponderInfo.LastName);
            request.SecondResponderInfo.FirstName = self.titleCasePipe.transform(request.SecondResponderInfo.FirstName);
            request.SecondResponderInfo.FullName =
                !!request.SecondResponderInfo.LastName && !!request.SecondResponderInfo.FirstName
                    ? request.SecondResponderInfo.LastName + ', ' + request.SecondResponderInfo.FirstName
                    : null;
        }
        request.ReferralIsClosed = ['DONEWINFO', 'DONENOINFO', 'CANCEL', 'DENIED', 'UNAVAIL', 'COMPLETED', 'CLOSEDNONINFO'].includes(request.Status);
        request.StatusLabel = self.referralStatusPipe.transform(request.Status, CurrentRole === 'BoardMember' || CurrentRole === 'BoardAssistant', request.Completed);
        request.ReferralFacilitatorStatus = self.referralFacilitatorStatusPipe.transform(request.Status);
        if (request.Comments && !!request.Comments.length) {
            request.Comments.forEach(function (c) {
                c.DateCommentAdded = c.DateCommentAdded ? new Date(c.DateCommentAdded) : null;
                c.HasRelatedLink = /Request #\d{4}-\d{3,}/.test(c.Comment);
                if (c.HasRelatedLink) {
                    var linkparts = c.Comment.match(/Request #(\d{4})-(\d{3,})/);
                    if (linkparts.length >= 3) {
                        c.RelatedRequestLinkYear = linkparts[1];
                        c.RelatedRequestLinkNumber = linkparts[2];
                    }
                }
            });
        }
        if (request.FollowUps && request.FollowUps.length) {
            var fatt_1 = [];
            request.FollowUps.forEach(function (f) {
                if (f.Attachments && f.Attachments.length) {
                    f.Attachments.forEach(function (t) { return fatt_1.push(t); });
                }
            });
            request.FollowUpAttachments = fatt_1;
        }
    };
    // #endregion
    // #region Get All Board Assistants Service Call
    ApplicationService.prototype.GetAllBoardAssistants = function () {
        return this.http.get(this.configService.hostAddress + "Api/Services/IRIS/GetAllBoardAssistants");
    };
    // #endregion
    // #region Get All Board Members Service Call
    ApplicationService.prototype.GetAllBoardMembers = function () {
        var self = this;
        return self._AllBoardMembers && !!self._AllBoardMembers.length
            ? of(self._AllBoardMembers)
            : self.http.get(self.configService.hostAddress + "Api/Services/IRIS/GetAllBoardMembers").pipe(map(function (data) {
                self._AllBoardMembers = data || [];
                return self._AllBoardMembers;
            }));
    };
    // #endregion
    // #region Get All Cabinet Members Service Call
    ApplicationService.prototype.GetAllCabinetMembers = function () {
        var self = this;
        return self.http.get(self.configService.hostAddress + "Api/Services/IRIS/GetAllCabinetMembers").pipe(map(function (data) {
            self._AllCabinetMembers = data || [];
            return self._AllCabinetMembers;
        }));
    };
    // #endregion
    // #region Get All Referrals For SAPID Service Call
    ApplicationService.prototype.GetAllReferralsForSAPID = function (AuthToken, CurrentRole, SAPID) {
        var self = this;
        return this.http
            .get(this.configService.hostAddress +
            "Api/Services/IRIS/GetAllReferralsForSAPID" +
            ("?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&SAPID=" + (SAPID || '')))
            .pipe(map(function (results) {
            if (results && !!results.length) {
                results.forEach(function (result) {
                    self.FormatRequestInfo(result, CurrentRole);
                });
            }
            return results;
        }));
    };
    // #endregion
    // #region Get All Categories Service Call
    ApplicationService.prototype.GetAllCategories = function () {
        var self = this;
        return self.http.get(self.configService.hostAddress + 'Api/Services/IRIS/GetAllCategories').pipe(map(function (cats) {
            self._AllCategories = cats;
            return cats;
        }));
    };
    // #endregion
    // #region Get All Constituents Service Call
    ApplicationService.prototype.GetAllConstituents = function (AuthToken) {
        var self = this;
        return self._AllConstituents && !!self._AllConstituents.length
            ? of(self._AllConstituents).pipe(take(1))
            : this.http.get(this.configService.hostAddress + ("Api/Services/IRIS/GetAllRequestConstituents?AuthToken=" + (AuthToken || '')));
    };
    // #endregion
    // #region Get All Facilitators Service Call
    ApplicationService.prototype.GetAllFacilitators = function () {
        return this.http.get(this.configService.hostAddress + "Api/Services/IRIS/GetAllFacilitators");
    };
    // #endregion
    // #region Get All Referred To Users Service Call
    ApplicationService.prototype.GetAllReferredToUsers = function (AuthToken) {
        return this.http
            .get(this.configService.hostAddress + ("Api/Services/IRIS/GetAllReferredToUsers?AuthToken=" + (AuthToken || '')))
            .pipe(map(function (data) {
            return data;
        }));
    };
    // #endregion
    // #region Get All Schools Service Call
    ApplicationService.prototype.GetAllSchools = function () {
        var self = this;
        if (self._AllSchools && !!self._AllSchools.length) {
            // We already have the list of schools in session storage. Just return that
            // instead of hitting the server again.
            // Use the of() wrapper to turn the session storage data into an observable.
            return of(self._AllSchools).pipe(take(1));
        }
        else {
            // No, it has not been loaded yet or is lost. Fetch it from the server again.
            return this.http.get(this.configService.hostAddress + "Api/Services/IRIS/GetAllSchools").pipe(map(function (data) {
                // Store what we were just sent in session storage.
                self._AllSchools = data;
                return data;
            }));
        }
    };
    // #endregion
    // #region Get All School Years Service Call
    ApplicationService.prototype.GetAllSchoolYears = function () {
        var self = this;
        return self._AllSchoolYears
            ? of(self._AllSchoolYears).pipe(take(1))
            : self.http.get(self.configService.hostAddress + "Api/Services/IRIS/GetAllFiscalYears").pipe(map(function (years) {
                self._AllSchoolYears = years;
                return years;
            }));
    };
    // #endregion
    // #region Get All Subordinates Service Call
    ApplicationService.prototype.GetAllSubordinates = function (AuthToken, CurrentRole, SAPID) {
        var self = this;
        return self._AllSubordinatesSupervisorSAPID === SAPID && self._AllSubordinates && self._AllSubordinates.length
            ? of(self._AllSubordinates)
            : self.http
                .get(self.configService.hostAddress +
                "Api/Services/IRIS/GetAllSubordinates" +
                ("?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&SAPID=" + (SAPID || '')))
                .pipe(map(function (data) {
                self._AllSubordinatesSupervisorSAPID = SAPID;
                self._AllSubordinates = data;
                return data;
            }));
    };
    // #endregion
    // #region Get All Supervisors Service Call
    ApplicationService.prototype.GetAllSupervisors = function (AuthToken) {
        var self = this;
        return self._AllSupervisors && !!self._AllSupervisors.length
            ? of(self._AllSupervisors).pipe(take(1))
            : this.http
                .get(this.configService.hostAddress + ("Api/Services/IRIS/GetAllSupervisors?AuthToken=" + (AuthToken || '')))
                .pipe(map(function (users) {
                if (users && !!users.length) {
                    users.forEach(function (user) {
                        user.LastName = user.EmployeeLastName;
                        user.FirstName = user.EmployeeFirstName;
                        user.Location = user.OrgUnitName;
                        user.SAPID = user.EmployeeSAPID;
                    });
                }
                self._AllSupervisors = users;
                return users;
            }));
    };
    // #endregion
    // #region Get Current School Year Service Call
    ApplicationService.prototype.GetCurrentSchoolYear = function () {
        var _this = this;
        return this._CurrentSchoolYear
            ? of(this._CurrentSchoolYear).pipe(take(1))
            : this.http.get(this.configService.hostAddress + "Api/Services/IRIS/GetCurrentSchoolYear").pipe(map(function (year) {
                _this._CurrentSchoolYear = year;
                return year;
            }));
    };
    // #endregion
    // #region Get Dashboard Summary Stats Service Call
    ApplicationService.prototype.GetDashboardSummaryStats = function (AuthToken, CurrentRole) {
        return this.http.get(this.configService.hostAddress +
            "Api/Services/IRIS/GetDashboardSummaryStats" +
            ("?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '')));
    };
    // #endregion
    // #region Get Due Date "Service" Call
    ApplicationService.prototype.GetDueDate = function (addedDays) {
        var self = this;
        var today = new Date();
        var dueDate = startOfDay(today);
        if (addedDays === 0) {
            return dueDate;
        }
        // Use the loaded work day calendar to look up the work day for today's date (if possible), then advance by the number of days
        // indicated and look up that date as well.
        // TODO: Do this more efficiently (binary search on date?)
        var tgtDueDate = null;
        if (self._WorkdayCalendars && !!self._WorkdayCalendars.length) {
            // First, try to retrieve the entry matching today's date.
            var dbtoday_1 = self._WorkdayCalendars.find(function (w) { return isSameDay(w.CalendarDate, today); });
            if (dbtoday_1 != null) {
                // We found today's date. Now, if today's date is a workday -AND- it's currently 4pm or later, we will need
                // to advance to the next business day before applying any priority due date adjustments.
                // We also should do this if today's date is a weekend or known holiday day as well.
                if ((today.getHours() >= 16 && dbtoday_1.WorkDay) || isWeekend(today) || dbtoday_1.WorkDay !== true) {
                    // The current time is after 4pm on a work day, or is a weekend day, or is a non-workday. Update the dbtoday
                    // to be the next possible workday (if known)
                    dbtoday_1 = self.GetNextWorkDay(dbtoday_1);
                }
                // Now, using the FY work day number, advance that by the requested number of days.
                var targetFYDayNum_1 = dbtoday_1.FYWorkDayNum + addedDays;
                // And try to look up the matching calendar date for that figure.
                var dbdue = self._WorkdayCalendars.find(function (w) { return w.FYWorkDayNum === targetFYDayNum_1 && w.FiscalYear === dbtoday_1.FiscalYear; });
                if (dbdue != null) {
                    // We have the target date
                    tgtDueDate = dbdue.CalendarDate;
                }
                else {
                    // We were unable to find the target date based upon the FY work day number. That may not be an
                    // error, though. If we are near the end of the FY (such as June 29), the target date may lie
                    // "outside" of the current FY into the next. We will substract the maximum FY work day number
                    // from the target, then try again in the other fiscal year.
                    var maxFYDayNum = self._WorkdayCalendars
                        .filter(function (w) { return w.FiscalYear === dbtoday_1.FiscalYear && w.FYWorkDayNum != null; })
                        .sort(function (a, b) { return b.FYWorkDayNum - a.FYWorkDayNum; })[0].FYWorkDayNum;
                    var nextFYDayNum_1 = targetFYDayNum_1 - maxFYDayNum;
                    var nextFY_1 = self.GetNextFiscalYear(dbtoday_1.FiscalYear);
                    // Try again.
                    dbdue = self._WorkdayCalendars.find(function (w) { return w.FYWorkDayNum === nextFYDayNum_1 && w.FiscalYear === nextFY_1; });
                    if (dbdue != null) {
                        tgtDueDate = dbdue.CalendarDate;
                    }
                }
            }
        }
        // If we were unable to find the due date using the "official" calendars, just fallback to a regular non-weekend date system.
        if (tgtDueDate == null) {
            // Add the days, being sure to only use weekdays (M-F) for now, until we have a better way of doing this.
            for (var i = 1; i <= addedDays;) {
                dueDate = addDays(dueDate, 1);
                if (!isWeekend(dueDate)) {
                    ++i;
                } // Only advance our counter if the date we just came to is not a weekend.
            }
            return dueDate;
        }
        else {
            return tgtDueDate;
        }
    };
    // #endregion
    // #region Get Email Preferences Service Call
    ApplicationService.prototype.GetEmailPreferences = function (AuthToken, CurrentRole) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/IRIS/GetEmailPreferences?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '')));
    };
    // #endregion
    // #region Get Email Preference Options Service Call
    ApplicationService.prototype.GetEmailPreferenceOptions = function () {
        var _this = this;
        return this._AllEmailPreferenceOptions && !!this._AllEmailPreferenceOptions.length
            ? of(this._AllEmailPreferenceOptions)
            : this.http
                .get(this.configService.hostAddress + "Api/Services/IRIS/GetEmailPreferenceOptions")
                .pipe(map(function (opts) {
                _this._AllEmailPreferenceOptions = opts;
                return opts;
            }));
    };
    // #endregion
    // #region Get File Attachment List Service Call
    ApplicationService.prototype.GetFileAttachmentList = function (AuthToken, RequestID) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/IRIS/GetFileAttachmentList?AuthToken=" + (AuthToken || '') + "&RequestID=" + (RequestID || '')))
            .pipe(map(function (data) {
            if (data && !!data.length) {
                data.forEach(function (d) {
                    d.DateUploaded = d.DateUploaded ? new Date(d.DateUploaded) : null;
                });
            }
            return data;
        }));
    };
    // #endregion
    // #region Get Next Fiscal Year
    ApplicationService.prototype.GetNextFiscalYear = function (year) {
        return year.substring(0, 2) + (+year.substring(2, 4) + 1) + year.substring(4, 6) + (+year.substring(6) + 1);
    };
    // #endregion
    // #region Get Next Work Day
    ApplicationService.prototype.GetNextWorkDay = function (today) {
        var self = this;
        if (!today) {
            return today;
        }
        // Premise here is basic. If we have loaded workday calendars, try to
        // get the one whose work day # is one more than the one we were given.
        // If we don't have the calendars, just roll to the next non-weekend day.
        if (self._WorkdayCalendars && self._WorkdayCalendars.length) {
            var tgtDay_1 = today.FYWorkDayNum + 1;
            var dbnext = self._WorkdayCalendars.find(function (w) { return w.FYWorkDayNum === tgtDay_1 && w.FiscalYear === today.FiscalYear; });
            if (dbnext != null) {
                // We have the target. Return it.
                return dbnext;
            }
            else {
                // Unable to find a target date based upon the FY work day number. This
                // can happen near the end of the FY (such as June 29), and so the target
                // date may lie "outside" of the current FY into the next. We will subtract
                // the maximum FY work day number from the target, then try again in the other
                // fiscal year.
                var maxFYDayNum = self._WorkdayCalendars
                    .filter(function (w) { return w.FiscalYear === today.FiscalYear && w.FYWorkDayNum != null; })
                    .sort(function (a, b) { return b.FYWorkDayNum - a.FYWorkDayNum; })[0].FYWorkDayNum;
                var nextFYDayNum_2 = tgtDay_1 - maxFYDayNum;
                var nextFY_2 = self.GetNextFiscalYear(today.FiscalYear);
                dbnext = self._WorkdayCalendars.find(function (w) { return w.FYWorkDayNum === nextFYDayNum_2 && w.FiscalYear === nextFY_2; });
                if (dbnext != null) {
                    return dbnext;
                }
                else {
                    return today;
                }
            }
        }
        else {
            return today;
        }
    };
    // #endregion
    // #region Get Out Of Office Settings By Cabinet SAPID Service Call
    ApplicationService.prototype.GetOutOfOfficeSettingsByCabinetSAPID = function (AuthToken, CurrentRole, CabinetSAPID) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/IRIS/GetOutOfOfficeSettingsByCabinetSAPID?AuthToken=" + (AuthToken || '')) +
            ("&CurrentRole=" + (CurrentRole || '') + "&CabinetSAPID=" + (CabinetSAPID || '')))
            .pipe(map(function (data) {
            if (data && data.length) {
                data.forEach(function (d) {
                    d.DateBegin = d.DateBegin ? new Date(d.DateBegin) : null;
                    d.DateEnd = d.DateEnd ? new Date(d.DateEnd) : null;
                });
            }
            return data;
        }));
    };
    // #endregion
    // #region Get Out Of Office Setting By ID Service Call
    ApplicationService.prototype.GetOutOfOfficeSettingByID = function (AuthToken, CurrentRole, OutOfOfficeSettingID) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/IRIS/GetOutOfOfficeSettingByID?AuthToken=" + (AuthToken || '')) +
            ("&CurrentRole=" + (CurrentRole || '') + "&OutOfOfficeSettingID=" + (OutOfOfficeSettingID || '')))
            .pipe(map(function (data) {
            data.DateBegin = data.DateBegin ? new Date(data.DateBegin) : null;
            data.DateEnd = data.DateEnd ? new Date(data.DateEnd) : null;
            return data;
        }));
    };
    // #endregion
    // #region Get Referral Job Time Service Call
    ApplicationService.prototype.GetReferralJobTime = function (AuthToken, RequestID) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/IRIS/GetReferralJobTime?AuthToken=" + (AuthToken || '') + "&RequestID=" + (RequestID || '')));
    };
    // #endregion
    // #region Get Related Request Service Call
    ApplicationService.prototype.GetRelatedRequest = function (AuthToken, CurrentRole, RelatedRequestLinkYear, RelatedRequestLinkNumber) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/IRIS/GetRelatedRequest?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole ||
                '') + "&RelatedRequestLinkYear=" + (RelatedRequestLinkYear || '') + "&RelatedRequestLinkNumber=" + (RelatedRequestLinkNumber ||
                '')));
    };
    // #endregion
    // #region Get Request Service Call
    ApplicationService.prototype.GetRequest = function (AuthToken, CurrentRole, RequestID, WithReferral) {
        var self = this;
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/IRIS/GetRequest?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole ||
                '') + "&IRISRequestID=" + (RequestID || '')) +
            ("&WithReferral=" + (WithReferral || '')))
            .pipe(map(function (request) {
            self.FormatRequestInfo(request, CurrentRole);
            return request;
        }));
    };
    // #endregion
    // #region Get Role List Service Call
    ApplicationService.prototype.GetRoleList = function () {
        var _this = this;
        return this._AllRoles && !!this._AllRoles.length
            ? of(this._AllRoles)
            : this.http.get(this.configService.hostAddress + "Api/Services/IRIS/GetRoleList").pipe(map(function (data) {
                _this._AllRoles = data;
                return data;
            }));
    };
    // #endregion
    // #region Get Superintendent Summary Stats Service Call
    ApplicationService.prototype.GetSuperintendentSummaryStats = function (AuthToken, CurrentRole) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/IRIS/GetSuperintendentSummaryStats?AuthToke=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '')));
    };
    // #endregion
    // #region Get Workday Calendar Service Call
    ApplicationService.prototype.GetWorkdayCalendar = function (IncludeNextYear) {
        var _this = this;
        return this._WorkdayCalendars && !!this._WorkdayCalendars.length
            ? of(this._WorkdayCalendars)
            : this.http
                .get(this.configService.hostAddress +
                "Api/Services/IRIS/GetWorkdayCalendar" +
                ("?IncludeNextYear=" + (IncludeNextYear != null ? IncludeNextYear : '')))
                .pipe(map(function (days) {
                if (days && !!days.length) {
                    days.forEach(function (d) {
                        d.CalendarDate = d.CalendarDate ? new Date(d.CalendarDate) : null;
                    });
                }
                _this._WorkdayCalendars = days;
                return days;
            }));
    };
    // #endregion
    // #region Is Valid Workday "Service" Call
    ApplicationService.prototype.IsValidWorkday = function (d) {
        if (!d) {
            return false;
        }
        var day = d.getDay();
        if (!this._WorkdayCalendars || !this._WorkdayCalendars.length) {
            // Without a workday calendar loaded, just assume anything is a workday if it is not on a weekend.
            return day !== 0 && day !== 6;
        }
        // Look up the provided date in the workdays calendars.
        var dbday = this._WorkdayCalendars.find(function (w) { return isSameDay(d, w.CalendarDate); });
        if (!dbday) {
            // Cannot tell. Default to checking weekend day.
            return day !== 0 && day !== 6;
        }
        else {
            return dbday.WorkDay;
        }
    };
    // #endregion
    // #region Mark Board Time Service Call
    ApplicationService.prototype.MarkBoardTime = function (AuthToken, CurrentRole, BoardInfo) {
        var self = this;
        return self.http
            .post(self.configService.hostAddress + "Api/Services/IRIS/MarkBoardTime", {
            AuthToken: AuthToken || '',
            CurrentRole: CurrentRole || '',
            infoObject: {
                ReferralID: (BoardInfo && BoardInfo.ReferralID) || '',
                ResponderNotes: (BoardInfo && BoardInfo.ResponderNotes) || '',
                TimeAction: (BoardInfo && BoardInfo.TimeAction) || '',
                Priority: (BoardInfo && BoardInfo.Priority) || '',
                DueDate: (BoardInfo && BoardInfo.DueDate) || '',
            },
        })
            .pipe(map(function (data) {
            self.FormatRequestInfo(data, CurrentRole);
            return data;
        }));
    };
    // #endregion
    // #region Perform Search Service Call
    ApplicationService.prototype.PerformSearch = function (AuthToken, CurrentRole, SearchParams) {
        var self = this;
        return this.http
            .post(this.configService.hostAddress + "Api/Services/IRIS/PerformSearch", {
            AuthToken: AuthToken,
            CurrentRole: CurrentRole,
            SearchYear: SearchParams.srchYear,
            SearchIssueNumber: SearchParams.srchIssueNum,
            SearchRequestedBy: SearchParams.srchRequestedBy,
            SearchType: SearchParams.srchType,
            SearchDateBegin: SearchParams.srchDateBegin,
            SearchDateEnd: SearchParams.srchDateEnd,
            SearchSubject: SearchParams.srchSubject,
            SearchSchool: SearchParams.srchSchool,
            SearchReferredTo: SearchParams.srchReferredTo,
            SearchReferredBy: SearchParams.srchReferredBy,
            SearchConstituent: SearchParams.srchSource,
            SearchCategoryID: SearchParams.srchCategoryID,
            SearchDistrict: SearchParams.srchDistrict,
            SearchPriority: SearchParams.srchPriority,
            SearchUnassignedOnly: SearchParams.srchUnassignedOnly,
            SearchNeedingAction: SearchParams.srchNeedingAction,
        })
            .pipe(map(function (results) {
            if (results && !!results.length) {
                results.forEach(function (result) {
                    self.FormatRequestInfo(result, CurrentRole);
                });
            }
            return results;
        }));
    };
    // #endregion
    // #region Reactivate Out Of Office Setting Service Call
    ApplicationService.prototype.ReactivateOutOfOfficeSetting = function (AuthToken, CurrentRole, OutOfOfficeSettingID) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/IRIS/ReactivateOutOfOfficeSetting?AuthToken=" + (AuthToken || '')) +
            ("&CurrentRole=" + (CurrentRole || '') + "&OutOfOfficeSettingID=" + (OutOfOfficeSettingID || '')))
            .pipe(map(function (data) {
            if (data && data.length) {
                data.forEach(function (d) {
                    d.DateBegin = d.DateBegin ? new Date(d.DateBegin) : null;
                    d.DateEnd = d.DateEnd ? new Date(d.DateEnd) : null;
                });
            }
            return data;
        }));
    };
    // #endregion
    // #region Recall Request Service Call
    ApplicationService.prototype.RecallRequest = function (AuthToken, CurrentRole, RequestID) {
        var self = this;
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/IRIS/RecallRequest?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&RequestID=" + (RequestID ||
                '')));
    };
    // #endregion
    // #region Redirect Request Service Call
    ApplicationService.prototype.RedirectRequest = function (AuthToken, CurrentRole, RedirectInformation) {
        var self = this;
        return this.http.post(this.configService.hostAddress + "Api/Services/IRIS/RedirectRequest", {
            AuthToken: AuthToken,
            CurrentRole: CurrentRole,
            infoObject: RedirectInformation,
        });
    };
    // #endregion
    // #region Referral Forward To Recipient Service Call
    ApplicationService.prototype.ReferralForwardToRecipient = function (AuthToken, CurrentRole, ForwardInfo) {
        var self = this;
        return this.http
            .post(this.configService.hostAddress + "Api/Services/IRIS/ReferralForwardToRecipient", {
            AuthToken: AuthToken,
            CurrentRole: CurrentRole,
            infoObject: ForwardInfo,
        })
            .pipe(map(function (request) {
            self.FormatRequestInfo(request, CurrentRole);
            return request;
        }));
    };
    // #endregion
    // #region Referral Mark Unavailable Service Call
    ApplicationService.prototype.ReferralMarkUnavailable = function (AuthToken, CurrentRole, UnavailInfo) {
        var self = this;
        return this.http
            .post(this.configService.hostAddress + "Api/Services/IRIS/ReferralMarkUnavailable", {
            AuthToken: AuthToken,
            CurrentRole: CurrentRole,
            infoObject: UnavailInfo,
        })
            .pipe(map(function (request) {
            self.FormatRequestInfo(request, CurrentRole);
            return request;
        }));
    };
    // #endregion
    // #region Referral Request Time Service Call
    ApplicationService.prototype.ReferralRequestTime = function (AuthToken, CurrentRole, TimeInfo) {
        var self = this;
        return this.http
            .post(this.configService.hostAddress + "Api/Services/IRIS/ReferralRequestTime", {
            AuthToken: AuthToken,
            CurrentRole: CurrentRole,
            infoObject: TimeInfo,
        })
            .pipe(map(function (request) {
            self.FormatRequestInfo(request, CurrentRole);
            return request;
        }));
    };
    // #endregion
    // #region Remove Board Assistant Service Call
    ApplicationService.prototype.RemoveBoardAssistant = function (AuthToken, CurrentRole, BoardAssistantID) {
        return this.http.get(this.configService.hostAddress +
            "Api/Services/IRIS/RemoveBoardAssistant" +
            ("?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&BoardAssistantID=" + (BoardAssistantID || '')));
    };
    // #endregion
    // #region Remove Cabinet Member Service Call
    ApplicationService.prototype.RemoveCabinetMember = function (AuthToken, CurrentRole, SAPID) {
        var _this = this;
        return this.http
            .get(this.configService.hostAddress +
            "Api/Services/IRIS/RemoveCabinetMember" +
            ("?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&SAPID=" + (SAPID || '')))
            .pipe(map(function (cabinetmembers) {
            _this._AllCabinetMembers = cabinetmembers || [];
            return _this._AllCabinetMembers;
        }));
    };
    // #endregion
    // #region Remove Category Service Call
    ApplicationService.prototype.RemoveCategory = function (AuthToken, CurrentRole, CategoryID) {
        return this.http.get(this.configService.hostAddress +
            "Api/Services/IRIS/RemoveCategory" +
            ("?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&CategoryID=" + (CategoryID || '')));
    };
    // #endregion
    // #region Remove Facilitator Service Call
    ApplicationService.prototype.RemoveFacilitator = function (AuthToken, CurrentRole, FacilitatorID) {
        return this.http.get(this.configService.hostAddress +
            "Api/Services/IRIS/RemoveFacilitator" +
            ("?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&FacilitatorID=" + (FacilitatorID || '')));
    };
    // #endregion
    // #region Request Cancel Service Call
    ApplicationService.prototype.RequestCancel = function (AuthToken, CurrentRole, RequestID) {
        var self = this;
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/IRIS/RequestCancel?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole ||
                '') + "&RequestID=" + (RequestID || '')))
            .pipe(map(function (request) {
            self.FormatRequestInfo(request, CurrentRole);
            return request;
        }));
    };
    // #endregion
    // #region Search For Employee By SAPID Service Call
    ApplicationService.prototype.SearchForEmployeeBySAPID = function (AuthToken, SAPID) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/IRIS/SearchForEmployeeBySAPID?AuthToken=" + (AuthToken || '') + "&SAPID=" + (SAPID || '')));
    };
    // #endregion
    // #region Search For User Service Call
    ApplicationService.prototype.SearchForUser = function (AuthToken, CurrentRole, FirstName, LastName, SAPID) {
        return this.http.post(this.configService.hostAddress + "Api/Services/IRIS/SearchForUser", {
            AuthToken: AuthToken || '',
            CurrentRole: CurrentRole || '',
            FirstName: FirstName || '',
            LastName: LastName || '',
            SAPID: SAPID || '',
        });
    };
    // #endregion
    // #region Set Email Preference Service Call
    ApplicationService.prototype.SetEmailPreference = function (AuthToken, CurrentRole, EmailPreferenceID, EmailPreferenceOptionID, RoleID, NonOwner, InstantEmail, DailyRoundupEmail) {
        return this.http.get(this.configService.hostAddress +
            "Api/Services/IRIS/SetEmailPreference" +
            ("?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&EmailPreferenceID=" + (EmailPreferenceID || '')) +
            ("&EmailPreferenceOptionID=" + (EmailPreferenceOptionID || '') + "&RoleID=" + (RoleID || '') + "&NonOwner=" + (NonOwner === true ? 'true' : 'false')) +
            ("&InstantEmail=" + (InstantEmail === true ? 'true' : 'false') + "&DailyRoundupEmail=" + (DailyRoundupEmail === true ? 'true' : 'false')));
    };
    // #endregion
    // #region Toggle Theme Service Call
    ApplicationService.prototype.ToggleTheme = function () {
        this.ThemeSubject.next(!this.ThemeSubject.value);
    };
    // #endregion
    // #region Update Referral Service Call
    ApplicationService.prototype.UpdateReferral = function (AuthToken, CurrentRole, ReferralDetails) {
        return this.http.post(this.configService.hostAddress + "Api/Services/IRIS/UpdateReferral", {
            AuthToken: AuthToken,
            CurrentRole: CurrentRole,
            infoObject: {
                IRISRequestId: ReferralDetails.RequestID,
                IRISReferralId: ReferralDetails.ReferralID,
                ReferralStatus: ReferralDetails.ReferralStatus,
                EstimatedJobTime: ReferralDetails.ReferralEstimatedJobTime,
                ActualJobTime: ReferralDetails.ReferralActualJobTime,
                StatusNote: ReferralDetails.ReferralNote,
                RequestResponse: ReferralDetails.RequestResponse,
                ReferrerNotes: ReferralDetails.ReferralReferrerNotes,
                ReferralResponse: ReferralDetails.ReferralResponse,
            },
        });
    };
    // #endregion
    // #region Update Request Service Call
    ApplicationService.prototype.UpdateRequest = function (AuthToken, CurrentRole, RequestDetails) {
        var self = this;
        return this.http
            .post(this.configService.hostAddress + "Api/Services/IRIS/UpdateRequest", {
            AuthToken: AuthToken,
            infoObject: {
                IRISRequestID: RequestDetails.RequestID,
                RequestText: RequestDetails.RequestText,
                Status: RequestDetails.Status,
                RequestCloseNote: RequestDetails.RequestCloseNote,
                // RequestSource: RequestDetails.RequestSource,
                // RequestSourceDescription: RequestDetails.RequestSourceDescription,
                Subject: RequestDetails.Subject,
                SchoolNumber: RequestDetails.SchoolNumber,
                CategoryID: RequestDetails.RequestCategory.CategoryID,
                BoardDistrict: RequestDetails.BoardDistrict,
                Priority: RequestDetails.Priority,
                RequestResponse: RequestDetails.RequestResponse,
                ReferralTarget: RequestDetails.ResponderInfo.SAPID,
                ReferralDeadline: RequestDetails.DueDate,
                ReferralMessage: RequestDetails.RequestReferredMessage,
            },
        })
            .pipe(map(function (request) {
            self.FormatRequestInfo(request, CurrentRole);
            return request;
        }));
    };
    // #endregion
    // #region Update Request Status Service Call
    ApplicationService.prototype.UpdateRequestStatus = function (AuthToken, CurrentRole, RequestDetails) {
        var self = this;
        return this.http
            .post(self.configService.hostAddress + "Api/Services/IRIS/UpdateRequestStatus", {
            AuthToken: AuthToken,
            infoObject: {
                RequestID: RequestDetails.RequestID,
                Status: RequestDetails.Status,
                RequestCloseNote: RequestDetails.RequestCloseNote,
                SourceNotes: RequestDetails.SourceNotes,
            },
        })
            .pipe(map(function (request) {
            self.FormatRequestInfo(request, CurrentRole);
            return request;
        }));
    };
    // #endregion
    // #region Upsert Categories Service Call
    ApplicationService.prototype.UpsertCategories = function (AuthToken, CurrentRole, Updates) {
        return this.http.post(this.configService.hostAddress + "Api/Services/IRIS/UpsertCategories", {
            AuthToken: AuthToken || '',
            CurrentRole: CurrentRole || '',
            Categories: Updates || '',
        });
    };
    // #endregion
    // #region Upsert Out Of Office Setting Service Call
    ApplicationService.prototype.UpsertOutOfOfficeSetting = function (AuthToken, CurrentRole, OutOfOfficeSettingID, CabinetSAPID, DesigneeSAPID, DateBegin, DateEnd, Active, Categories) {
        return this.http
            .post(this.configService.hostAddress + "Api/Services/IRIS/UpsertOutOfOfficeSetting", {
            AuthToken: AuthToken || '',
            CurrentRole: CurrentRole || '',
            OutOfOfficeSettingID: OutOfOfficeSettingID != null ? OutOfOfficeSettingID : '',
            CabinetSAPID: CabinetSAPID || '',
            DesigneeSAPID: DesigneeSAPID || '',
            DateBegin: DateBegin != null ? DateBegin.toJSON() : '',
            DateEnd: DateEnd != null ? DateEnd.toJSON() : '',
            Active: Active != null ? Active : '',
            Categories: Categories || '',
        })
            .pipe(map(function (data) {
            if (data && data.length) {
                data.forEach(function (d) {
                    d.DateBegin = d.DateBegin ? new Date(d.DateBegin) : null;
                    d.DateEnd = d.DateEnd ? new Date(d.DateEnd) : null;
                });
            }
            return data;
        }));
    };
    ApplicationService.ngInjectableDef = i0.defineInjectable({ factory: function ApplicationService_Factory() { return new ApplicationService(i0.inject(i1.HttpClient), i0.inject(i2.CategoryPipe), i0.inject(i3.ConfigService), i0.inject(i4.SessionStorageService), i0.inject(i5.ReferralFacilitatorStatusPipe), i0.inject(i6.ReferralStatusPipe), i0.inject(i7.RequestIssuePipe), i0.inject(i8.RequestStatusPipe), i0.inject(i9.TitleCasePipe)); }, token: ApplicationService, providedIn: "root" });
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", Array)
    ], ApplicationService.prototype, "_AllBoardMembers", void 0);
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", Array)
    ], ApplicationService.prototype, "_AllCabinetMembers", void 0);
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", Array)
    ], ApplicationService.prototype, "_AllCategories", void 0);
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", Array)
    ], ApplicationService.prototype, "_AllConstituents", void 0);
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", Array)
    ], ApplicationService.prototype, "_AllEmailPreferenceOptions", void 0);
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", Array)
    ], ApplicationService.prototype, "_AllReferredToUsers", void 0);
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", Array)
    ], ApplicationService.prototype, "_AllRoles", void 0);
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", Array)
    ], ApplicationService.prototype, "_AllSchoolYears", void 0);
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", Array)
    ], ApplicationService.prototype, "_AllSubordinates", void 0);
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", String)
    ], ApplicationService.prototype, "_AllSubordinatesSupervisorSAPID", void 0);
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", Array)
    ], ApplicationService.prototype, "_AllSupervisors", void 0);
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", String)
    ], ApplicationService.prototype, "_CurrentSchoolYear", void 0);
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", String)
    ], ApplicationService.prototype, "_LoadedSchoolYear", void 0);
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", Array)
    ], ApplicationService.prototype, "_AllSchools", void 0);
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", CurrentRequestInfo)
    ], ApplicationService.prototype, "_CurrentRequest", void 0);
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", Array)
    ], ApplicationService.prototype, "_WorkdayCalendars", void 0);
    return ApplicationService;
}());
export { ApplicationService };
// #region Custom Classes
// #region Add Request Class
var AddRequest = /** @class */ (function () {
    function AddRequest() {
    }
    return AddRequest;
}());
export { AddRequest };
// #endregion
// #region Board Member Info Class
var BoardMemberInfo = /** @class */ (function () {
    function BoardMemberInfo() {
    }
    return BoardMemberInfo;
}());
export { BoardMemberInfo };
// #endregion
// #region Category Info Class
var CategoryInfo = /** @class */ (function () {
    function CategoryInfo() {
    }
    return CategoryInfo;
}());
export { CategoryInfo };
// #endregion
// #region Create Options Class
var CreateOptions = /** @class */ (function () {
    function CreateOptions() {
    }
    return CreateOptions;
}());
export { CreateOptions };
// #endregion
// #region Current Request Info Class
var CurrentRequestInfo = /** @class */ (function () {
    function CurrentRequestInfo() {
    }
    return CurrentRequestInfo;
}());
export { CurrentRequestInfo };
// #endregion
// #region Dashboard Data Class
var DashboardData = /** @class */ (function () {
    function DashboardData() {
    }
    return DashboardData;
}());
export { DashboardData };
// #endregion
// #region Email Preference Class
var EmailPreference = /** @class */ (function () {
    function EmailPreference() {
    }
    return EmailPreference;
}());
export { EmailPreference };
// #endregion
// #region Email Preference Option Class
var EmailPreferenceOption = /** @class */ (function () {
    function EmailPreferenceOption() {
    }
    return EmailPreferenceOption;
}());
export { EmailPreferenceOption };
// #endregion
// #region Employee Info Class
var EmployeeInfo = /** @class */ (function () {
    function EmployeeInfo() {
    }
    return EmployeeInfo;
}());
export { EmployeeInfo };
// #endregion
// #region File Attachment Info Class
var FileAttachmentInfo = /** @class */ (function () {
    function FileAttachmentInfo() {
    }
    return FileAttachmentInfo;
}());
export { FileAttachmentInfo };
// #endregion
// #region New Request Info Class
var NewRequestInfo = /** @class */ (function () {
    function NewRequestInfo() {
    }
    return NewRequestInfo;
}());
export { NewRequestInfo };
// #endregion
// #region Out Of Office Setting Class
var OutOfOfficeSetting = /** @class */ (function () {
    function OutOfOfficeSetting() {
    }
    return OutOfOfficeSetting;
}());
export { OutOfOfficeSetting };
// #endregion
// #region Person Info Class
var PersonInfo = /** @class */ (function () {
    function PersonInfo() {
    }
    return PersonInfo;
}());
export { PersonInfo };
// #endregion
// #region Redirect Info Class
var RedirectInfo = /** @class */ (function () {
    function RedirectInfo() {
    }
    return RedirectInfo;
}());
export { RedirectInfo };
// #endregion
// #region Referral Info Class
var ReferralInfo = /** @class */ (function () {
    function ReferralInfo() {
    }
    return ReferralInfo;
}());
export { ReferralInfo };
// #endregion
// #region Referral Options Class
var ReferralOptions = /** @class */ (function () {
    function ReferralOptions() {
    }
    return ReferralOptions;
}());
export { ReferralOptions };
// #endregion
// #region Referral Update Info Class
var ReferralUpdateInfo = /** @class */ (function () {
    function ReferralUpdateInfo() {
    }
    return ReferralUpdateInfo;
}());
export { ReferralUpdateInfo };
// #endregion
// #region Request Comment Info Class
var RequestCommentInfo = /** @class */ (function () {
    function RequestCommentInfo() {
    }
    return RequestCommentInfo;
}());
export { RequestCommentInfo };
// #endregion
// #region Request FollowUp Info
var RequestFollowUpInfo = /** @class */ (function () {
    function RequestFollowUpInfo() {
    }
    return RequestFollowUpInfo;
}());
export { RequestFollowUpInfo };
// #endregion
// #region Request Info Class
var RequestInfo = /** @class */ (function (_super) {
    tslib_1.__extends(RequestInfo, _super);
    function RequestInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RequestInfo;
}(CreateOptions));
export { RequestInfo };
// #endregion
// #region Request Response Info Class
var RequestResponseInfo = /** @class */ (function () {
    function RequestResponseInfo() {
    }
    return RequestResponseInfo;
}());
export { RequestResponseInfo };
// #endregion
// #region Request Summary Statistics Class
var RequestSummaryStatistics = /** @class */ (function () {
    function RequestSummaryStatistics() {
    }
    return RequestSummaryStatistics;
}());
export { RequestSummaryStatistics };
// #endregion
// #region Role Info Class
var RoleInfo = /** @class */ (function () {
    function RoleInfo() {
    }
    return RoleInfo;
}());
export { RoleInfo };
// #endregion
// #region School Info Class
var SchoolInfo = /** @class */ (function () {
    function SchoolInfo() {
    }
    return SchoolInfo;
}());
export { SchoolInfo };
// #endregion
// #region Search Parameters Class
var SearchParameters = /** @class */ (function () {
    function SearchParameters() {
    }
    return SearchParameters;
}());
export { SearchParameters };
// #endregion
// #region Summary Statistics Class
var SummaryStatistics = /** @class */ (function () {
    function SummaryStatistics() {
    }
    return SummaryStatistics;
}());
export { SummaryStatistics };
// #endregion
// #region Upsert Category Info Class
var UpsertCategoryInfo = /** @class */ (function () {
    function UpsertCategoryInfo() {
    }
    return UpsertCategoryInfo;
}());
export { UpsertCategoryInfo };
// #endregion
// #region User Search Result Class
var UserSearchResult = /** @class */ (function () {
    function UserSearchResult() {
    }
    return UserSearchResult;
}());
export { UserSearchResult };
// #endregion
// #region Workday Calendar Info Class
var WorkdayCalendarInfo = /** @class */ (function () {
    function WorkdayCalendarInfo() {
    }
    return WorkdayCalendarInfo;
}());
export { WorkdayCalendarInfo };
